import { Component, Input } from '@angular/core';

@Component({
  selector: 'jacking-alert-container',
  templateUrl: 'jacking-alert-container.component.html'
})
export class JackingAlertContainerComponent {
  @Input() alertText: string;
  @Input() alertTextArray: string[];

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/pages/jacking-activities/v2/components/jacking-alert-container/jacking-alert-container.component.ts